import './App.css';
import Main from './components/layout/Main/Main.js';
import Header from './components/layout/Header/Header.js';
import Footer from './components/layout/Footer/Footer.js';

function App() {
  return (
    <div className="App">
      <Header />
      <Main />
      <Footer />
    </div>
  );
}

export default App;
